import React from 'react'
import css from './index.module.less'

export default () => <div className={css.loading}>
        <span />
        <span />
        <span />
        <span />
        <span />
    </div>